import { PMLineGaugeCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { calculateMaturityGauge } from "product-test-utils";

import { DashboardCardContext } from "../context";

export function addOeMaturityLevelCard(ctx: DashboardCardContext) {
  const { view, language } = ctx;

  const oeMaturityLevelComponent = view.addComponent({
    component: PMLineGaugeCard,
    layoutProps: {
      componentId: "oeMaturityLevelComponent",
      labels: ["maturity", "dimension", "gauge"],
      title:
        getLocalizedMessage(language, "cards.dimensionMaturityLevel.title") ||
        "Dimension Maturity Levels",
      description:
        getLocalizedMessage(
          language,
          "cards.dimensionMaturityLevel.description"
        ) ||
        "Shows numeric maturity progress for each dimension and the average across them.",
    },
  });

  oeMaturityLevelComponent.mapLayoutProps(({ language }) => ({
    componentId: "oeMaturityLevelComponent",
    labels: ["maturity", "dimension", "gauge"],
    title:
      getLocalizedMessage(language, "cards.dimensionMaturityLevel.title") ||
      "Dimension Maturity Levels",
    description:
      getLocalizedMessage(
        language,
        "cards.dimensionMaturityLevel.description"
      ) ||
      "Shows numeric maturity progress for each dimension and the average across them.",
  }));

  oeMaturityLevelComponent.mapState(({ dashboard, language, settings }) => {
    const maturityItems =
      dashboard?.projects?.flatMap((project) => project.reportingItems ?? []) ??
      [];
    const gaugeState = calculateMaturityGauge({
      items: maturityItems,
      configuration: settings?.configuration,
    });

    return {
      title:
        getLocalizedMessage(language, "cards.dimensionMaturityLevel.title") ||
        "Dimension Maturity Levels",
      icon: "ShowChart",
      entries: gaugeState
        ? [
            {
              label: getLocalizedMessage(language, "average") || "Average",
              value: gaugeState.averageValue,
              percentage: gaugeState.averagePercentage,
              precision: 3,
              isTitle: true,
              color: gaugeState.averageColor,
            },
            ...gaugeState.dimensions.map((dimension) => ({
              label: dimension.name,
              value: dimension.value,
              percentage: dimension.percentage,
              precision: 2,
              color: dimension.color,
            })),
          ]
        : [],
      scale: gaugeState?.scale ?? [1],
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  oeMaturityLevelComponent.mapVisibility(({ settings }) => {
    return settings?.configuration?.useCase === "maturity";
  });
}
